import { render, staticRenderFns } from "./CButtons.vue?vue&type=template&id=6774b172&scoped=true"
import script from "./CButtons.vue?vue&type=script&lang=js"
export * from "./CButtons.vue?vue&type=script&lang=js"
import style0 from "./CButtons.vue?vue&type=style&index=0&id=6774b172&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6774b172",
  null
  
)

export default component.exports